import React, { Component } from 'react';
class getLoading extends Component {
  render() {
    return (
      <div style={{"width":"100%","height":"100%"}}>
        <center>
          <img alt="Cargando Imagen . . ." src={ require('../image/loading.gif') } />
        </center>
      </div>
    );
  }
}
export default getLoading;
